<template>
  <div class="tripmaps">
    <h2 class="title-bunner-container">
      <img class="title-bunner" src="../assets/bunner/map.png" alt="旅の地図">
    </h2>
    <div class="container">
      <div v-if="!loading" class="row">
        <div class="col-md-3 mb-3 border">
          <div class="pt-3 row">
            <div class="col-12 px-5">
              <img class="img-title" src="/static/guidebook/trip_maps.png" alt="かつうら旅の地図">
            </div>
            <b-button
              class="col-6 col-md-12"
              variant="link"
              v-for="(item, key) in bunners"
              :key="key"
            >
              <img
                class="bunner"
                :class="{'bunner-inactive': !item.active}"
                :src="item.image"
                :alt="item.name"
                @click="onSelect(key)"
              >
            </b-button>
          </div>
        </div>
        <map-view
          class="col-md-9 map-container"
          :markers="this.locations.markers"
          :center="this.locations.center"
          :zoom="this.locations.scale"
          @click-marker="onClickMarker"
        ></map-view>
      </div>
      <div class="text-center" v-else>
        <p class="pt-5 pb-5 loading" v-if="loading">Loading...</p>
      </div>
    </div>
    <modal-info :show="showModal" :data="location"></modal-info>
  </div>
</template>
<script>
import WpClient from "../wpClient.js";
import MapView from "@/components/MapView.vue";
import ModalInfo from "@/components/ModalLocationInfo.vue";
import utils from "@/utils";
export default {
  data() {
    return {
      showModal: false,
      bunners: {
        eat: {
          id: 2,
          active: true,
          image: "/static/guidebook/bunner_eat.png",
          name: "たべる"
        },
        buy: {
          id: 3,
          active: true,
          image: "/static/guidebook/bunner_buy.png",
          name: "買う"
        },
        watch: {
          id: 4,
          active: true,
          image: "/static/guidebook/bunner_watch.png",
          name: "観る"
        },
        stay: {
          id: 5,
          active: true,
          image: "/static/guidebook/bunner_stay.png",
          name: "泊まる"
        },
        experience: {
          id: 6,
          active: true,
          image: "/static/guidebook/bunner_experience.png",
          name: "体験する"
        }
      },
      filter: {},
      loading: true,
      location: {},
      locations: [],
      pages: []
    };
  },
  components: {
    MapView,
    ModalInfo
  },
  async mounted() {
    let raw = await WpClient.getLocations();
    this.pages = raw;
    this.locations = utils.convertMapLocations(raw);
    this.loading = false;
  },
  methods: {
    onSelect(key) {
      console.log("onSelect");
      let bunnersArray = Object.values(this.bunners);
      if (bunnersArray.filter(function(item) {return item.active}).length == 5) {
        bunnersArray.forEach(function(item) {
          item.active = false;
        });
      }
      this.bunners[key].active = !this.bunners[key].active;

      if (bunnersArray.filter(function(item) {return item.active}).length == 0) {
        bunnersArray.forEach(function(item) {
          item.active = true;
        });
      }

      let pages = this.pages.filter(function(item) {
        return item.categories.find(function(item2) {
          return bunnersArray.find(function(item3) {
            console.log(item.title.rendered, item2, item3.id, item3.active);
            return item3.active && item3.id == item2;
          });
        });
      });
      this.locations = utils.convertMapLocations(pages);
    },
    onClickMarker(marker) {
      console.log("on click marker");
      this.location = this.pages.find(function(item) {
        return item.title.rendered == marker.title;
      });
      this.$bvModal.show("modal-location-info");
    }
  }
};
</script>
<style lang="scss">
.tripmaps {
  .map-container {
    .map,
    .map-view {
      height: 600px;
      @media (min-width: 576px) {
        // width: 450px;
      }
      /* // 中デバイス（タブレット, 768px 以上） */
      @media (min-width: 768px) {
        height: 408px;
      }

      /* // 大デバイス（デスクトップ, 992px 以上） */
      @media (min-width: 992px) {
        height: 538px;
      }

      /* // 特大デバイス（ワイド・デスクトップ, 1200px 以上） */
      @media (min-width: 1200px) {
        height: 638px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.bunner {
  width: 100%;
}

.img-title {
  max-width: 70%;
  padding: 2rem 0;
}

.bunner-inactive {
  filter: brightness(60%);
}
</style>
